import 'zone.js';
// main.ts — early patch (temporary)
function ensureFocusedItemMutate() {
  try {
    // Patch any object that looks like focusedItemInfo when mutate is missing
    const originalDefineProperty = Object.defineProperty;
    // Intercept assignments to window for Kendo internals (best-effort)
    (window as any).__ensureKendoMutate = () => {
      try {
        // If Kendo exposes prototypes you can patch them here, otherwise patch instances lazily
        // Lazy patch helper
        const patch = (obj: any) => {
          if (!obj) return;
          if (typeof obj.mutate !== 'function') {
            (obj as any).mutate = (updater: any) => {
              if (typeof updater === 'function') {
                try { updater(obj); } catch { }
              } else if (typeof updater === 'object') {
                Object.assign(obj, updater);
              }
            };
          }
        };
        // Patch global factory points if present
        const maybe = (window as any).kendo;
        if (maybe && maybe.ui) {
          // Try common prototypes
          const MenuProto = maybe.ui.Menu?.prototype;
          if (MenuProto && !MenuProto.__mutatePatched) {
            const orig = MenuProto.onItemClick;
            MenuProto.onItemClick = function (...args: any[]) {
              patch(this.focusedItemInfo);
              return orig && orig.apply(this, args);
            };
            MenuProto.__mutatePatched = true;
          }
        }
        // Also patch DOM event handlers fallback
        document.addEventListener('click', (ev) => {
          const target = ev.target as any;
          if (target && target.__kendoFocusedItemInfo) patch(target.__kendoFocusedItemInfo);
        }, true);
      } catch (e) { /* swallow */ }
    };
    (window as any).__ensureKendoMutate();
  } catch (e) { }
}
ensureFocusedItemMutate();








try {
  // Put ALL global fixes here
  (window as any).__CRITERION__ = {
    getFeatureFlagOverride: () => false
  };

  // Safe widget loader (optional)
  (function loadJsdWidget() {
    const script = document.createElement('script');
    script.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
    script.async = true;

    script.onload = () => {
      document.dispatchEvent(
        new Event('DOMContentLoaded', { bubbles: true, cancelable: true })
      );
    };

    document.head.appendChild(script);
  })();

} catch (err) {
  console.error('GLOBAL INIT ERROR:', err);
}

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

try {
if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    loadEmbedScript();
    //if ('serviceWorker' in navigator && environment.production) {
    //  navigator.serviceWorker.register('./ngsw-worker.js');
    //}
  })
  .catch(err => console.error(err));
} catch (err) {
  console.error('FATAL ANGULAR ERROR:', err);
  document.body.innerHTML = `
    <h2 style="color:red; padding:20px;">
      A fatal error occurred, but the page is still visible.
    </h2>
  `;
}
function loadEmbedScript() {
  const script = document.createElement('script');
  script.src = 'https://your-domain.com/embed.js';
  script.async = true;

  script.onload = () => {
    console.log('embed.js loaded');

    // Call init if required
    if ((window as any).embedInit) {
      (window as any).embedInit();
    }
  };

  document.body.appendChild(script);
}

